/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body[_ngcontent-%COMP%] {\n  height: 100vh; }\n\n.headermaster[_ngcontent-%COMP%] {\n  background-color: #043169; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/account/forgot-password/forgot-password.component.scss.shim.ngstyle.js.pre-build-optimizer.js